import React, { Component } from 'react';
import btcIcon from '../resources/BTClogo.png'
import usdIcon from '../resources/USDlogo.png';

class BTCConverter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btcValue: props.value ?? props.btcAmount ?? 0,
            usdValue: null,
            displayCurrency: 'BTC',
        };
    }

    componentDidMount() {
        this.fetchExchangeRate();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value || prevProps.btcAmount !== this.props.btcAmount) {
            this.setState({ btcValue: this.props.value ?? this.props.btcAmount ?? 0 });
        }
    }

    fetchExchangeRate = async () => {
        try {
            this.setState({ usdValue: null });
        } catch (error) {
            console.error('Error fetching exchange rate:', error);
        }
    };

    toggleDisplayCurrency = () => {
        this.setState(prevState => ({
            displayCurrency: prevState.displayCurrency === 'BTC' ? 'USD' : 'BTC'
        }));
    };

    render() {
        const { btcValue, usdValue, displayCurrency } = this.state;
        const { className = '' } = this.props;

        const iconStyle = {
            width: '35px',
            height: '35px',
            marginRight: '4px',
            cursor: 'pointer'
        };

        const containerStyle = {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit'
        };

        return (
            <span className={`btc-converter ${className}`} style={containerStyle}>
                <img 
                    src={displayCurrency === 'BTC' ? btcIcon : usdIcon} 
                    alt={displayCurrency} 
                    style={iconStyle} 
                    onClick={this.toggleDisplayCurrency}
                />
                {displayCurrency === 'BTC' 
                    ? `${btcValue.toFixed(8)} BTC`
                    : usdValue !== null 
                        ? `$${(btcValue * usdValue).toFixed(2)} USD`
                        : 'USD unavailable'
                }
            </span>
        );
    }
}

export default BTCConverter;
